import { Heading, Link } from '@chakra-ui/react';

export default function Brand() {
    return (
        <Heading size = "md" as = { Link } href = "/">
            Ben Fryxell | Cellist
        </Heading>
    );
};